// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiBaseUrl: 'https://acpbus-staging.azurewebsites.net/api/',
  // apiBaseUrl: "http://103.82.240.130:7001/api/",
  // apiBaseUrl: "http://103.82.241.173:8009/api/",
  apiBaseUrl: "http://staging.radyalabs.id:7035/api/",
  // apiBaseUrl: "http://103.82.240.130:7041/api/",
  // apiBaseUrl: 'https://qa-gateaway.ezrx.id/api/',
  // apiBaseUrl: 'https://apl-phase-3.radyalabs.id/api/',
  // apiBaseUrl: "https://apl-cr6-cms.radyalabs.id/api/",
  // apiBaseUrl: "https://apq.ezrx.id/api/",
  // apiBaseUrl: "https://apd.ezrx.id/api/",
  //apiBaseUrl: 'https://app.ezrx.id/api/',
  apiBaseUrlGt: "http://178.128.90.130:8011",
  // apiBaseUrlGt: "https://apqreg-gateway.ezrx.id",
  apiClientKey: "sUjLrBaPILUnl8dHjrxeSX1GuVEVlxmR6ikALiN5L1",
  apiSecretKey: "VCA0d42gBfhZIbfVS2D6NZWT3dCQrOMMYw76DAagez",
  apiBaseUrlPromo: "http://staging.radyalabs.id:7041/promo/",
  // apiBaseUrlPromo: "http://staging.radyalabs.id:7042/api/",
  // apiBaseUrlPromo: 'https://qa-gateaway.ezrx.id/promo/',

  // Firebase
  //Production
  // firebaseConfig: {
  //   apiKey: 'AIzaSyBIk-nCvmaTPPPbPyVpVNxUBkTYak3TOls',
  //   authDomain: 'aplcp-ezrx.firebaseapp.com',
  //   databaseURL: 'https://aplcp-ezrx.firebaseio.com',
  //   projectId: 'aplcp-ezrx',
  //   storageBucket: 'aplcp-ezrx.appspot.com',
  //   messagingSenderId: '757098342527',
  //   appId: '1:757098342527:web:07bb920bfcb8ab330bb74a',
  //   measurementId: 'G-L47V0JZ7XM'
  // }

  //Staging
  firebaseConfig: {
    apiKey: "AIzaSyBtltE4xvXBIsyutnbYo7UuRZqll3cK7nc",
    authDomain: "aplcp-ezrx-staging.firebaseapp.com",
    databaseURL: "https://aplcp-ezrx-staging.firebaseio.com",
    projectId: "aplcp-ezrx-staging",
    storageBucket: "aplcp-ezrx-staging.appspot.com",
    messagingSenderId: "822165861149",
    appId: "1:822165861149:web:3e81387407c99dc61067f4",
    measurementId: "G-74964CVQNF",
  },

  // Google Maps
  googleApiKey: "AIzaSyCunpqAtLGr-X5bY7hT5z_Fq8L0jQw4iwM",
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
